<template>
    <emc-card-stats 
        color="blue lighten-1"
        icon="mdi-school-outline"
        icon-large
        :title="this.title"
        :value="this.teachers"
        sub-text="Número de professores ativos"
        >
        <template v-slot:actions>
            <emc-button-icon btn-small :loading="loading" icon="mdi-refresh-circle" :text="updated_at || `Atualizar`" color="success" @click.prevent.stop="refresh()" />
        </template>
    </emc-card-stats>
</template>

<script>

import { mapActions } from 'vuex'

export default {
    name: 'EmcChartTeacherNumber',
    data () {
        return {
            teachers: '0',
            title: '',
            updated_at: null,
            loading: false,
            attempts: 1
        }
    },
    methods: {
        ...mapActions('chart', ['ActionChartTeacherNumber', 'ActionTeacherNumbersRefresh']),
        async getData() {
            await this.ActionChartTeacherNumber()
                .then((r) => {
                    this.teachers = r.data.value.toString()
                    this.title = r.data.title
                    this.updated_at = r.data.updated_at
                })
        },
        refresh() {
            this.loading = true

            this.ActionTeacherNumbersRefresh()
                .then(() => {
                    this.getDataRefresh()
                })
        },
        getDataRefresh()
        {
            let number = this.teachers;

            setTimeout(async () => {

                    await this.getData()
                    
                    if(number != this.teachers || this.attempts == 3) {
                        this.loading = false
                    } else {
                        this.attempts++
                        this.getDataRefresh()
                    }

            }, 5000)
        }
    },
    created(){
        this.getData()
    }

    
}
</script>